import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { preloadAssets } from './assetCache';
import { PRELOAD_IMAGES, PRELOAD_VIDEOS } from '../assets';
import { loadTeamPhotos } from './teamPhotos';

export function usePreload(enabled = true) {
  const [state, setState] = useState({ pct: 0, done: 0, total: 1, label: '', ready: false, failed: [] });
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    loadTeamPhotos()
      .then((team) => preloadAssets({ videos: PRELOAD_VIDEOS, images: [...PRELOAD_IMAGES, ...team.map((p) => p.url)] }, (p) => alive && setState((s) => ({ ...s, ...p }))))
      .then(({ failed }) => alive && setState((s) => ({ ...s, pct: 100, ready: true, failed })));
    return () => { alive = false; };
  }, [enabled]);
  return state;
}

// Full-screen READY gate shown before presenter mode begins.
export function ReadyScreen({ preload, title, subtitle, onBegin, autoBegin }) {
  useEffect(() => {
    if (preload.ready && autoBegin) {
      const id = setTimeout(onBegin, 600);
      return () => clearTimeout(id);
    }
    return undefined;
  }, [preload.ready, autoBegin, onBegin]);

  return (
    <div className="pk-ready" data-testid="pk-ready-screen">
      <div className="pk-ready-glow" />
      <img src="/nichecom-logo.png" alt="NicheCom" className="pk-ready-logo" />
      <div className="pk-ready-title">{title}</div>
      <div className="pk-ready-sub">{subtitle}</div>
      <div className="pk-ready-bar"><motion.div className="pk-ready-fill" animate={{ width: `${preload.pct}%` }} transition={{ ease: 'linear', duration: 0.3 }} /></div>
      {preload.ready ? (
        <>
          <motion.div className="pk-ready-word" initial={{ opacity: 0, letterSpacing: '0.6em' }} animate={{ opacity: 1, letterSpacing: '0.35em' }} transition={{ duration: 0.9 }}>READY</motion.div>
          <button className="pk-btn pk-btn-lime pk-btn-xl" onClick={onBegin} data-testid="pk-begin-btn">Begin presentation</button>
          <div className="pk-ready-hint">Space pause · ← → navigate · F fullscreen · Esc exit</div>
          {preload.failed.length > 0 && <div className="pk-ready-warn">{preload.failed.length} asset(s) will stream instead of play from memory.</div>}
        </>
      ) : (
        <div className="pk-ready-status" data-testid="pk-ready-status">Preparing assets · {preload.pct}%</div>
      )}
    </div>
  );
}
